import { Navigate } from 'react-router-dom'
export default function OfflineRoute({ children }) {
  if (process.env.OFFLINE) {
    return <Navigate to="/login" replace={true} />
  } else {
    return <>{children}</>
  }
}
